import React from 'react';

const BoxBurstingStars1 = (props) => {
  const { svgClass, pathClass, width, height } = props;
  
  return (
    <svg id="Layer_2" className={svgClass} width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.5 34">
      <g id="fi_867818" data-name="fi 867818">
        <g id="Group_1413371446" data-name="Group 1413371446">
          <g id="Group_1413371445" data-name="Group 1413371445">
            <g id="Group">
              <g id="Group_2" data-name="Group 2">
                <path id="Vector" className={pathClass}
                      d="m2.96,4.89c-.28,0-.5.23-.5.5v1.33c0,.28.22.5.5.5s.5-.23.5-.5v-1.33c0-.28-.23-.5-.5-.5Z"/>
              </g>
            </g>
            <g id="Group_3" data-name="Group 3">
              <g id="Group_4" data-name="Group 4">
                <path id="Vector_2" data-name="Vector 2" className={pathClass}
                      d="m2.96,8.48c-.28,0-.5.23-.5.5v1.33c0,.28.22.5.5.5s.5-.23.5-.5v-1.33c0-.28-.23-.5-.5-.5Z"/>
              </g>
            </g>
          </g>
          <g id="Group_5" data-name="Group 5">
            <g id="Group_6" data-name="Group 6">
              <path id="Vector_3" data-name="Vector 3" className={pathClass}
                    d="m5.42,7.35h-1.33c-.28,0-.5.23-.5.5s.23.5.5.5h1.33c.28,0,.5-.23.5-.5s-.23-.5-.5-.5Z"/>
            </g>
          </g>
          <g id="Group_7" data-name="Group 7">
            <g id="Group_8" data-name="Group 8">
              <path id="Vector_4" data-name="Vector 4" className={pathClass}
                    d="m1.83,7.35H.5c-.28,0-.5.23-.5.5s.23.5.5.5h1.33c.28,0,.5-.23.5-.5s-.23-.5-.5-.5Z"/>
            </g>
          </g>
          <g id="Group_9" data-name="Group 9">
            <g id="Group_10" data-name="Group 10">
              <path id="Vector_5" data-name="Vector 5" className={pathClass}
                    d="m28.36,19.39l-3.42-3.54h0s0,0,0,0c-.05-.05-.12-.1-.19-.12l-2.95-1.05c-.26-.09-.55.04-.64.3-.09.26.04.55.3.64l1.63.58-8.33,2.97-8.33-2.97,1.67-.6c.26-.09.4-.38.3-.64-.09-.26-.38-.4-.64-.3l-3,1.07c-.07.03-.14.07-.19.12,0,0,0,0,0,0h0s-3.42,3.54-3.42,3.54c-.12.12-.17.3-.13.46.04.17.16.3.32.36l6.02,2.15c.06.02.11.03.17.03.21,0,.4-.13.47-.33.09-.26-.04-.55-.3-.64l-5.28-1.88,2.65-2.75,8.79,3.13-2.65,2.75-1.71-.61c-.26-.09-.55.04-.64.3-.09.26.04.55.3.64l2.01.72c.19.07.39.02.53-.12l3.06-3.17,3.06,3.17c.1.1.23.15.36.15.06,0,.11,0,.17-.03l9.83-3.51c.16-.06.28-.19.32-.36.04-.17,0-.34-.13-.46Zm-10.05,3.27l-2.65-2.75,8.79-3.13,2.65,2.75-8.79,3.13Z"/>
            </g>
          </g>
          <g id="Group_11" data-name="Group 11">
            <g id="Group_12" data-name="Group 12">
              <path id="Vector_6" data-name="Vector 6" className={pathClass}
                    d="m20.49,31.45c-.09-.26-.38-.4-.64-.3l-5.1,1.82-9.33-3.33v-6.86c0-.28-.23-.5-.5-.5s-.5.23-.5.5v7.21c0,.21.13.4.33.47l9.83,3.51c.05.02.11.03.17.03s.11,0,.17-.03l5.27-1.88c.26-.09.4-.38.3-.64Z"/>
            </g>
          </g>
          <g id="Group_13" data-name="Group 13">
            <g id="Group_14" data-name="Group 14">
              <path id="Vector_7" data-name="Vector 7" className={pathClass}
                    d="m24.58,22.28c-.28,0-.5.23-.5.5v6.86l-2.29.82c-.26.09-.4.38-.3.64.07.21.27.33.47.33.06,0,.11,0,.17-.03l2.62-.94c.2-.07.33-.26.33-.47v-7.21c0-.28-.23-.5-.5-.5Z"/>
            </g>
          </g>
          <g id="Group_15" data-name="Group 15">
            <g id="Group_16" data-name="Group 16">
              <path id="Vector_8" data-name="Vector 8" className={pathClass}
                    d="m14.75,22.25c-.28,0-.5.23-.5.5v8.55c0,.28.23.5.5.5s.5-.23.5-.5v-8.55c0-.28-.23-.5-.5-.5Z"/>
            </g>
          </g>
          <g id="Group_17" data-name="Group 17">
            <g id="Group_18" data-name="Group 18">
              <path id="Vector_9" data-name="Vector 9" className={pathClass}
                    d="m25.51,5.7l-.95-.19c-.74-.15-1.32-.73-1.47-1.47l-.19-.95c-.09-.44-.46-.74-.91-.74s-.82.3-.91.74l-.19.95c-.15.74-.73,1.32-1.47,1.47l-.95.19c-.44.09-.74.46-.74.91s.3.82.74.91l.95.19c.74.15,1.32.73,1.47,1.47l.19.95c.09.44.46.74.91.74s.82-.3.91-.74l.19-.95c.15-.74.73-1.32,1.47-1.47l.95-.19c.44-.09.74-.46.74-.91s-.3-.82-.74-.91Zm-1.15,1.02c-1.14.23-2.03,1.12-2.26,2.26l-.11.56-.11-.56c-.23-1.14-1.12-2.03-2.26-2.26l-.56-.11.56-.11c1.14-.23,2.03-1.12,2.26-2.26l.11-.56.11.56c.23,1.14,1.12,2.03,2.26,2.26l.56.11-.56.11Z"/>
            </g>
          </g>
          <g id="Group_19" data-name="Group 19">
            <g id="Group_20" data-name="Group 20">
              <path id="Vector_10" data-name="Vector 10" className={pathClass}
                    d="m15.42,4.31l-1.22-.25c-1.01-.2-1.79-.99-2-2l-.25-1.22c-.1-.49-.52-.84-1.02-.84s-.92.34-1.02.84l-.25,1.22c-.2,1.01-.99,1.79-2,2l-1.22.25c-.49.1-.84.52-.84,1.02s.34.92.84,1.02l1.22.25c1.01.2,1.79.99,2,2l.25,1.22c.1.49.52.84,1.02.84s.92-.34,1.02-.84l.25-1.22c.2-1.01.99-1.79,2-2l1.22-.25c.49-.1.84-.52.84-1.02s-.34-.92-.84-1.02Zm-.2,1.06l-1.22.25c-1.41.29-2.5,1.38-2.78,2.78l-.25,1.22s0,.03-.04.03-.03,0-.04-.03l-.25-1.22c-.29-1.41-1.38-2.5-2.78-2.78l-1.22-.25s-.03,0-.03-.04,0-.03.03-.04l1.22-.25c1.41-.29,2.5-1.38,2.78-2.78l.25-1.22s0-.03.04-.03.03,0,.04.03l.25,1.22c.29,1.41,1.38,2.5,2.78,2.78l1.22.25s.03,0,.03.04,0,.03-.03.04Z"/>
            </g>
          </g>
          <g id="Group_21" data-name="Group 21">
            <g id="Group_22" data-name="Group 22">
              <path id="Vector_11" data-name="Vector 11" className={pathClass}
                    d="m11.27,15.93c-1.33-3.28-4.31-6.18-4.44-6.3-.2-.19-.52-.19-.71.01-.19.2-.19.52.01.71.03.03,2.96,2.88,4.21,5.96.08.2.27.31.47.31.06,0,.13-.01.19-.04.26-.1.38-.4.28-.66Z"/>
            </g>
          </g>
          <g id="Group_23" data-name="Group 23">
            <g id="Group_24" data-name="Group 24">
              <path id="Vector_12" data-name="Vector 12" className={pathClass}
                    d="m13.08,9.68c-.28,0-.5.23-.5.5v4.62c0,.28.23.5.5.5s.5-.23.5-.5v-4.62c0-.28-.23-.5-.5-.5Z"/>
            </g>
          </g>
          <g id="Group_25" data-name="Group 25">
            <g id="Group_26" data-name="Group 26">
              <path id="Vector_13" data-name="Vector 13" className={pathClass}
                    d="m21.77,11.46c-.22-.17-.53-.14-.71.07-1.25,1.54-2.17,3.02-2.73,4.4-.1.26.02.55.28.65.06.03.13.04.19.04.2,0,.39-.12.47-.31.65-1.6,1.76-3.14,2.58-4.15.17-.22.14-.53-.07-.71Z"/>
            </g>
          </g>
          <g id="Group_27" data-name="Group 27">
            <g id="Group_28" data-name="Group 28">
              <path id="Vector_14" data-name="Vector 14" className={pathClass}
                    d="m17.4,8.08c-.28-.04-.53.16-.56.43l-.81,6.23c-.04.28.16.53.43.56.02,0,.04,0,.07,0,.25,0,.47-.18.5-.44l.81-6.23c.04-.28-.16-.53-.43-.56Z"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BoxBurstingStars1;